import { scopedChannelApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ChannelApiResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { ReadRequestOptions } from '../../requestOptions';
import type { ExpansionDestination } from './types';

const validate = (subscriptionId: number, sourceSubscriptionId?: number) => {
  if (!subscriptionId || subscriptionId < 1) {
    throw new Error('Valid subscription ID is required');
  }
  if (sourceSubscriptionId !== undefined && (!sourceSubscriptionId || sourceSubscriptionId < 1)) {
    throw new Error('Source subscription ID must be a positive number');
  }
};

type RequestParams = {
  /**
   * Any subscription of the organization — the API authorises the caller against it and scopes
   * every read by organization, never by this id.
   */
  subscriptionId: number;
  /**
   * The one channel to preview products from. Omitted lists every ATTS-capable channel the
   * organization sells on rather than one named source's own destinations.
   */
  sourceSubscriptionId?: number;
};

export const getDestinations = async (
  scope: RequestScope,
  { subscriptionId, sourceSubscriptionId }: RequestParams,
  options: ReadRequestOptions
): Promise<ChannelApiResponse<ExpansionDestination[]>> => {
  try {
    validate(subscriptionId, sourceSubscriptionId);

    const result = await scopedChannelApi(scope).get<ExpansionDestination[]>('atts/expansion/destinations', {
      ...options,
      headers: {
        'x-astur-subscription-id': subscriptionId.toString(),
      },
      params: {
        source_subscription_id: sourceSubscriptionId,
      },
    });

    return {
      data: result.data,
      status: result.status,
    };
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
